"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  CategoriesContext: true,
  CategoriesProvider: true,
  MultiSiteContext: true,
  MultiSiteProvider: true,
  CurrencyContext: true,
  CurrencyProvider: true,
  ChatContext: true,
  ChatProvider: true
};
exports.MultiSiteProvider = exports.MultiSiteContext = exports.CurrencyProvider = exports.CurrencyContext = exports.ChatProvider = exports.ChatContext = exports.CategoriesProvider = exports.CategoriesContext = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contexts = require("../commerce-api/contexts");
var _constants = require("../constants");
var _LanguageContext = require("./LanguageContext");
Object.keys(_LanguageContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _LanguageContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageContext[key];
    }
  });
});
var _checkoutContext = require("./checkout-context");
Object.keys(_checkoutContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _checkoutContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkoutContext[key];
    }
  });
});
var _AccountOrdersContext = require("./AccountOrdersContext");
Object.keys(_AccountOrdersContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AccountOrdersContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccountOrdersContext[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * This is the global state for categories, we use this for navigation and for
 * the product list page.
 *
 * To use these context's simply import them into the component requiring context
 * like the below example:
 *
 * import React, {useContext} from 'react'
 * import {CategoriesContext} from './contexts'
 *
 * export const RootCategoryLabel = () => {
 *    const {categories} = useContext(CategoriesContext)
 *    return <div>{categories['root'].name}</div>
 * }
 *
 * Alternatively you can use the hook provided by us:
 *
 * import {useCategories} from './hooks'
 *
 * const {root, itemsKey, fetchCategoryNode} = useCategories()
 *
 */
// @ts-ignore
const CategoriesContext = exports.CategoriesContext = /*#__PURE__*/_react.default.createContext();
const CategoriesProvider = ({
  treeRoot = {},
  children,
  locale
}) => {
  var _treeRoot$DEFAULT_ROO, _treeRoot$DEFAULT_ROO2;
  const itemsKey = 'categories';
  const DEFAULT_ROOT_CATEGORY = 'root';
  const LOCAL_STORAGE_PREFIX = `pwa-kit-cat-`;
  const api = (0, _contexts.useCommerceAPI)();
  const [root, setRoot] = (0, _react.useState)(_objectSpread(_objectSpread({}, treeRoot[DEFAULT_ROOT_CATEGORY]), {}, {
    [itemsKey]: (_treeRoot$DEFAULT_ROO = treeRoot[DEFAULT_ROOT_CATEGORY]) === null || _treeRoot$DEFAULT_ROO === void 0 ? void 0 : (_treeRoot$DEFAULT_ROO2 = _treeRoot$DEFAULT_ROO[itemsKey]) === null || _treeRoot$DEFAULT_ROO2 === void 0 ? void 0 : _treeRoot$DEFAULT_ROO2.map(item => _objectSpread({}, item))
  }));
  const fetchCategoryNode = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (id, levels = 1) {
      const storageKey = `${LOCAL_STORAGE_PREFIX}${id}-${locale}`;
      // @ts-ignore
      const storageItem = JSON.parse(window.localStorage.getItem(storageKey));

      // return early if there's one that is less than stale time
      if (storageItem && Date.now() < storageItem.fetchTime + _constants.CAT_MENU_STALE_TIME) {
        return storageItem;
      }
      // get and store fresh data for faster access / reduced server load
      // TODO: Convert to useCategory hook when hooks are ready
      // @ts-ignore
      const res = yield api.shopperProducts.getCategory({
        parameters: {
          id,
          levels
        }
      });
      res.loaded = true;
      window.localStorage.setItem(storageKey, JSON.stringify(_objectSpread(_objectSpread({}, res), {}, {
        fetchTime: Date.now()
      })));
      return res;
    });
    return function fetchCategoryNode(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(() => {
    var _root$itemsKey;
    // Server side, we only fetch level 0 categories, for performance, here
    // we request the remaining two levels of category depth
    const promises = root === null || root === void 0 ? void 0 : (_root$itemsKey = root[itemsKey]) === null || _root$itemsKey === void 0 ? void 0 : _root$itemsKey.map(/*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(function* (cat) {
        return yield fetchCategoryNode(cat === null || cat === void 0 ? void 0 : cat.id, 2);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    if (promises) {
      // TODO: Error handling when fetching data fails.
      // Possibly switch to .allSettled to show partial data?
      Promise.all(promises).then(data => {
        setRoot(_objectSpread(_objectSpread({}, root), {}, {
          [itemsKey]: data
        }));
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(CategoriesContext.Provider, {
    value: {
      root,
      itemsKey,
      fetchCategoryNode
    }
  }, children);
};
exports.CategoriesProvider = CategoriesProvider;
CategoriesProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  treeRoot: _propTypes.default.object,
  locale: _propTypes.default.string
};

/**
 * This is the global state for the multiples sites and locales supported in the App.
 *
 * To use the context simply import them into the component requiring context
 * like the below example:
 *
 * import React, {useContext} from 'react'
 * import {MultiSiteContext} from './contexts'
 *
 * export const RootCurrencyLabel = () => {
 *    const {site,locale,urlTemplate} = useContext(MultiSiteContext)
 *    return <div>{site} {locale}</div>
 * }
 *
 * Alternatively you can use the hook provided by us:
 *
 * import {useMultiSite} from './hooks'
 *
 * const {site, locale, buildUrl} = useMultiSite()
 * @type {React.Context<unknown>}
 */
const MultiSiteContext = exports.MultiSiteContext = /*#__PURE__*/_react.default.createContext({});
const MultiSiteProvider = ({
  site: initialSite = {},
  locale: initialLocale = {},
  buildUrl,
  children
}) => {
  const [site, setSite] = (0, _react.useState)(initialSite);
  const [locale, setLocale] = (0, _react.useState)(initialLocale);
  return /*#__PURE__*/_react.default.createElement(MultiSiteContext.Provider, {
    value: {
      site,
      setSite,
      locale,
      setLocale,
      buildUrl
    }
  }, children);
};
exports.MultiSiteProvider = MultiSiteProvider;
MultiSiteProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  buildUrl: _propTypes.default.func,
  site: _propTypes.default.object,
  locale: _propTypes.default.object
};

/**
 * This is the global state for currency, we use this throughout the site. For example, on
 * the product-list, product-detail and cart and basket pages..
 *
 * To use these context's simply import them into the component requiring context
 * like the below example:
 *
 * import React, {useContext} from 'react'
 * import {CurrencyContext} from './contexts'
 *
 * export const RootCurrencyLabel = () => {
 *    const {currency} = useContext(CurrencyContext)
 *    return <div>{currency}</div>
 * }
 *
 * Alternatively you can use the hook provided by us:
 *
 * import {useCurrency} from './hooks'
 *
 * const {currency, setCurrency} = useCurrency()
 *
 */
const CurrencyContext = exports.CurrencyContext = /*#__PURE__*/_react.default.createContext({});
const CurrencyProvider = ({
  currency: initialCurrency,
  children
}) => {
  const [currency, setCurrency] = (0, _react.useState)(initialCurrency);
  return /*#__PURE__*/_react.default.createElement(CurrencyContext.Provider, {
    value: {
      currency,
      setCurrency
    }
  }, children);
};
exports.CurrencyProvider = CurrencyProvider;
CurrencyProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  currency: _propTypes.default.string
};

/**
 * This is the global state for chat initialization state, we use this throughout the site.
 *
 * To use this context simply import them into the component requiring context
 * like the below example:
 *
 * import React, {useContext} from 'react'
 * import {ChatContext} from './contexts'
 *
 * export const testFunction = () => {
 *    const {isInitialized, setIsInitialized} = useContext(ChatContext)
 *    setIsInitialized(true)
 *    console.log(isInitialized)
 * }
 *
 * Alternatively you can use the hook provided by us:
 *
 * import {useChat} from './hooks'
 *
 * const {isInitialized, setIsInitialized} = useChat()
 *
 */
const ChatContext = exports.ChatContext = /*#__PURE__*/_react.default.createContext({});
const ChatProvider = ({
  isInitialized: initialInitializationStatus,
  children
}) => {
  const [isInitialized, setIsInitialized] = (0, _react.useState)(initialInitializationStatus);
  return /*#__PURE__*/_react.default.createElement(ChatContext.Provider, {
    value: {
      isInitialized,
      setIsInitialized
    }
  }, children);
};
exports.ChatProvider = ChatProvider;
ChatProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  isInitialized: _propTypes.default.bool
};